import { Language } from '@/organisations/models';

export class QuestionTitle {
    language = Language.NL;
    title = '';
    subtitle?: string;

    deserialize(data: any) {
        this.language = data.language ?? Language.NL;
        this.title = data.title ?? '';
        this.subtitle = data.subtitle ?? undefined;
        return this;
    }

    serialize() {
        return {
            language: this.language,
            title: this.title,
            subtitle: this.subtitle,
        };
    }
}
